export enum InvestmentType {
  Core = 1,
  CorePlus = 2,
  ValueAdd = 3,
  Opportunistic = 4,
  Other = 5,
  Development = 6
  // if changing or adding values, update all other methods (toString, toList)
  // and backend enums
}

// tslint:disable-next-line:no-namespace
export namespace InvestmentType {
  export function toString(investmentType: InvestmentType): string {
    switch (investmentType) {
      case InvestmentType.Core:
        return 'Core';
      case InvestmentType.CorePlus:
        return 'Core plus';
      case InvestmentType.ValueAdd:
        return 'Value-add';
      case InvestmentType.Opportunistic:
        return 'Opportunistic';
      case InvestmentType.Other:
        return 'Other';
      case InvestmentType.Development:
        return 'Development';

      default:
        return null;
    }
  }

  export function listAll() {
    return [InvestmentType.Core, InvestmentType.CorePlus, InvestmentType.ValueAdd, InvestmentType.Opportunistic, InvestmentType.Development, InvestmentType.Other];
  }

  export function parse(investmentTypeStr: string): InvestmentType {
    return InvestmentType[investmentTypeStr];
  }

  export function OpportunisticLikeType(investmentType: InvestmentType) : boolean {
    return [InvestmentType.Opportunistic, InvestmentType.Development].includes(investmentType);
  }

  export function OpportunisticLikeOrValueAddType(investmentType: InvestmentType) : boolean {
    return [InvestmentType.Opportunistic, InvestmentType.Development, InvestmentType.ValueAdd].includes(investmentType);
  }
}

export default InvestmentType;
